import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import LoadingSpinner from '../dev/LoadingSpinner'
import { fromEvent } from 'rxjs'
import { debounceTime } from 'rxjs/operators';

const { REACT_APP_URI = '/' } = process.env
class AgencyPayment extends Component {
    state = {
        maxStep: 15, //設三的倍數
        paddingValue: 64,
        seatValue: 1,
        seatMinValue: 1,
        seatInputValue: 1,
        isSubmitDisabled: false,
        isLoading: false,
        IM: 'Admin',
        management:{
            totalSeats: '',
            remainSeats: '',
            usedSeats: '',
        },
        response: '',
    }
    componentDidMount = () => {
        const { match: { params: { condition } } } = this.props
        if (condition === 'Management') {
            fetch(`${REACT_APP_URI}/accounts/showCompanyInfo/`, { credentials: 'include' })
                .then(res => res.json())
                .then(({ IM, totalSeats, remainSeats, usedSeats }) => this.setState({ management: { totalSeats, remainSeats, usedSeats }, seatValue: totalSeats, seatMinValue: usedSeats, seatInputValue: totalSeats, maxStep: totalSeats > 15 ? totalSeats * 3 : 15, isSubmitDisabled: true, IM: IM,})
                )
        }
        else this.setState({ seatValue: 1, seatMinValue: 1, seatInputValue: 1})
        const infiniteSlider = fromEvent(document.querySelector('#observableSlider'), "input")
        infiniteSlider
            .pipe(debounceTime(400))
            .subscribe(e => {
                const {maxStep} = this.state
                if (e.target.value >= maxStep - 1) this.setState({ maxStep: maxStep + 15}); 
            })
    }
    getPaymentApiCase = () => {
        const { user: {plan}, user: {canITrial} } = this.props
        if (canITrial && plan === 'Free') return 'trial'
        if (plan === '' || plan === 'Free') return 'payment'
        else return 'upgrade'
    }
    getPaymentTextCase = () => {
        const {
            user: { plan, isTrialing, canITrial},
        } = this.props;
        if(isTrialing) { //是否試用中
            return 'trialing' //試用中
        }
        if(!canITrial) { //不可試用
            return plan === 'Free' 
                    ? 'trialedOrCanceled' //已試用過，未購買過
                    : 'dad' //已購買過
        }
        else return 'canTrial' //未試用，未購買，非試用中
    }
    sliderInput = e => {
        const { seatMinValue } = this.state
        if (e.target.value >= seatMinValue) { 
            this.setState({ seatValue: e.target.value, seatInputValue: e.target.value, isSubmitDisabled: false, })
        };
    }
    seatInput = e => {
        const { seatMinValue, management: { totalSeats} } = this.state
        this.setState({ seatInputValue: e.target.value });
        if (e.target.value > seatMinValue || !this.inValid(e.target.value)){
            if (Number(e.target.value) === totalSeats) this.setState({ isSubmitDisabled: true, seatValue: e.target.value });
            else this.setState({ isSubmitDisabled: false, seatValue: e.target.value });
        }
        else {
            const resetValue = totalSeats === '' ? 1 : totalSeats
            this.setState({ isSubmitDisabled: true, error: 'error', seatValue: resetValue });
        }
    }
    price = val => {
        if(val <= 5) {
            return val*199;
        }
        else if (5 < val && val <= 10){
            return 5*199 + (val-5)*99
        }
        else if (10<val){
            return 5 * 199 + 5 * 99 + (val-10)*29
        }
    }
    average = val => {
        const average = this.price(val)/val
        return Math.ceil(average)
    }
    earn = val => {
        const average = this.price(val)/val
        return Math.floor((1-(average/199))*100)
    }
    inValid = val => {
        const {seatMinValue} = this.state
        if (val < seatMinValue || isNaN(val) || val ===''){
            return true
        }
        else return false
    }
    seatSubmit = e => {
        const { price, getPaymentApiCase, getPaymentTextCase } = this
        const { seatValue } = this.state
        const { match: { params: { condition } }, user: { token }, messages} = this.props
        if (seatValue !== '') {
            if (condition === "Payment") this.props.dispatch({ 
                type: 'togglePaymentField',
                isPaymentActive: true,
                paymentApiCase: getPaymentApiCase(),
                paymentTextCase: getPaymentTextCase(),
                buyPlan: 'Agency', 
                buyAmount: '$' + price(seatValue), 
                seatNumber: seatValue })
            if (condition === "Management") {
                this.setState({ isLoading: true})
                fetch(`${REACT_APP_URI}/updatePlan/Agency/`, {
                    method: 'post',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        "X-CSRFToken": token,
                    },
                    body: JSON.stringify({ number: parseInt(seatValue, 10) })
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({ isLoading: false, response: messages.agency_payment_success }, () => setTimeout(() => {
                            this.props.history.push('/UserInfo')
                        }, 5000))
                    }
                    else {
                        this.setState({ isLoading: false, response: messages.agency_payment_error })
                    }
                })
            }
        }
    }
    seatReset = () => {
        const { match: { params: { condition } } } = this.props
        const { seatMinValue, management:{ totalSeats }} = this.state
        if (condition === 'Payment') this.setState({ seatValue: seatMinValue, seatInputValue: seatMinValue, isSubmitDisabled: false })
        if (condition === 'Management') this.setState({ seatValue: totalSeats, seatInputValue: totalSeats, isSubmitDisabled: true })
    }
    renderSliderTrack = () => {
        const { paddingValue, maxStep, seatValue } = this.state
        return (
            <SliderTrackWrap maxStep={maxStep} paddingValue={paddingValue}>
                {/* <SliderTrack width={`${5 / maxStep * 100}%`} backgroundColor="#de0606" /> */}
                <SliderTrack width={5 / maxStep * 100} backgroundColor="#de0606" transparentPart= {seatValue > 5 ? 1 : seatValue / 5}/>
                <SliderTrack width={5 / maxStep * 100} backgroundColor="#ee8282" transparentPart={seatValue > 10 ? 1 : (seatValue - 5)/5}/>
                <SliderTrack width={(maxStep - 10) / maxStep * 100} backgroundColor="#f5b4b4" transparentPart={seatValue > 10 ? (seatValue - 10)/(maxStep - 10) : (seatValue - 10) / 5}/>
            </SliderTrackWrap>
        )
    }
    renderScale = () => {
        const { maxStep, paddingValue} = this.state
        const scaleWidth = (900 - paddingValue * 2)*1/3
        return(
            <ScaleWrap paddingValue={paddingValue}>
                <svg viewbox="0 0 900 24">
                    <line x1={paddingValue} y1="0" x2={paddingValue} y2="24" stroke="#787878"/>
                    {maxStep <= 15 && <line x1={paddingValue + scaleWidth} y1="0" x2={paddingValue + scaleWidth} y2="24" stroke="#787878"/>}
                    {maxStep <= 15 && <line x1={paddingValue + scaleWidth * 2} y1="0" x2={paddingValue+ scaleWidth*2} y2="24" stroke="#787878"/>}
                </svg>
            </ScaleWrap>
        )
    }
    renderline = () => {
        const { paddingValue } = this.state
        return(
            <ScaleWrap paddingValue={paddingValue}>
                <svg viewbox="0 0 900 24">
                    <line x1={paddingValue-12} y1="12" x2={900 - paddingValue + 12} y2="12" stroke="#787878"/>
                </svg>
            </ScaleWrap>
        )
    }
    renderRegularPayment = () => {
        const { state: { seatValue, seatInputValue, isSubmitDisabled}, seatInput, seatSubmit, seatReset, price, average, earn} = this
        const {messages} = this.props
        return (
            <React.Fragment>
                <Wrap direction='column' top='24px'>
                    <SeatContent>
                        <SeatInput
                            onChange={seatInput}
                            value={seatInputValue}
                            onKeyPress={e => {
                                if (!isSubmitDisabled) {
                                    e.key === "Enter" && seatSubmit()
                                }
                                else e.key === "Enter" && seatReset()
                            }}
                            type="text" placeholder={messages.agency_payment_placeholder}
                        />
                        <SeatUser>{messages.agency_payment_user}</SeatUser>
                        <SeatSubmit onClick={() => !isSubmitDisabled && seatSubmit()} isSubmitDisabled={isSubmitDisabled}>{messages.contact_confirm} ${price(seatValue)}</SeatSubmit>
                    </SeatContent>
                    <SeatContent>
                        <SeatError>{isSubmitDisabled && messages.agency_payment_input_error}</SeatError>
                    </SeatContent>
                </Wrap>
                <NoteWrap>
                    <div>
                        {messages.agency_payment_averge_price_1} ${average(seatValue)}  {messages.agency_payment_averge_price_2}
                        <span>{earn(seatValue)}%</span>
                    </div>
                </NoteWrap>
            </React.Fragment>
        )
    }
    renderManagement = () => {
        const { price, average, earn, seatInput, seatSubmit, seatReset} = this
        const { messages } = this.props
        const { paddingValue, seatValue, seatInputValue, isSubmitDisabled, response, isLoading, management: { totalSeats, usedSeats }} = this.state
        return (
            <ManagementWrap paddingValue={paddingValue}>
                <Wrap direction='column'>
                    <Title>{messages.user_seat_current}</Title>
                    <ManagementTitle>{messages.user_seat_purchased}{totalSeats}</ManagementTitle>
                    <ManagementTitle>{messages.user_seat_used}{usedSeats}</ManagementTitle>
                    <ManagementTitle>{messages.user_seat_cost}${price(totalSeats)}</ManagementTitle>
                    <ManagementTitle>{messages.agency_payment_averge_price_1}：${average(totalSeats)}</ManagementTitle>
                </Wrap>
                <Wrap direction='column'>
                    <Title>{messages.user_seat_updated}</Title>
                    <ManagementTitle>
                        {messages.user_seat_purchased}
                        <SeatInput
                            onChange={seatInput}
                            value={seatInputValue}
                            onKeyPress={e => {
                                if (!isSubmitDisabled) {
                                    e.key === "Enter" && seatSubmit()
                                }
                                else e.key === "Enter" && seatReset()
                            }}
                            type="text" placeholder={messages.agency_payment_placeholder}
                            border
                        />
                        {!isLoading && response === '' && <div>*{messages.agency_payment_wtf}</div>}
                        {!isLoading && response !== '' && <Response>{response}</Response>}
                        {isLoading && <LoadingSpinner AgencyManagement size='20px'/>}
                    </ManagementTitle>
                    <ManagementTitle>{messages.user_seat_used}{usedSeats}</ManagementTitle>
                    <ManagementTitle>{messages.user_seat_cost}${price(seatValue)}</ManagementTitle>
                    <ManagementTitle>{messages.agency_payment_averge_price_1}：${average(seatValue)}<span>{messages.agency_payment_save} {earn(seatValue)}%</span></ManagementTitle>
                    <EditButtonWrap>
                        <EditButton isActive={!isSubmitDisabled} condition='comfirm' onClick={() => isSubmitDisabled ? seatReset() : seatSubmit()}>{messages.edit}</EditButton>
                        <EditButton isActive condition='cancel' onClick={() => this.props.history.goBack()}>{messages.cancel}</EditButton>
                    </EditButtonWrap>
                </Wrap>
            </ManagementWrap>
        )
    }
    render() {
        const { state: { seatValue, paddingValue}, sliderInput, renderSliderTrack, renderScale, renderline, renderRegularPayment, renderManagement } = this
        const { maxStep, IM } = this.state
        const { user: { auth, plan }, match: { params: { condition } }, messages } = this.props //判斷是payment還是management
        if (auth === 'notSignIn') this.props.history.push('/')
        if (condition === 'Payment' && plan === 'Agency') this.props.history.push('/') 
        if (condition === 'Management' && IM === 'Member') this.props.history.push('/') 
        return (
            <React.Fragment>
                <Container>
                    <Content>
                        <Wrap direction='column' padding={`24px 0 24px ${paddingValue}px`} borderBottom>
                            <Title>
                                {condition === 'Payment' && <React.Fragment>Agency {messages.plan}<span>*{messages.agency_payment_invite}</span></React.Fragment>}
                                {condition === 'Management' && messages.user_agency_add_seat}
                            </Title>
                        </Wrap>
                        <Wrap direction='column' padding={'24px 0'}>
                            {maxStep > 15 && <PriceWrap paddingValue={paddingValue}>
                                <PriceContent small>{messages.pricing_agency_1to5_1}</PriceContent>
                                <PriceContent small>{messages.pricing_agency_6to10_1}</PriceContent>
                                <PriceContent small>{messages.pricing_agency_11up_1}</PriceContent>
                            </PriceWrap>}
                            <PriceWrap paddingValue={paddingValue}>
                                <PriceContent>{messages.pricing_agency_per_user+` `+ messages.pricing_agency_1to5_3}</PriceContent>
                                <PriceContent>{messages.pricing_agency_per_user+` `+ messages.pricing_agency_6to10_3}</PriceContent>
                                <PriceContent>{messages.pricing_agency_per_user+` `+ messages.pricing_agency_11up_3}</PriceContent>
                            </PriceWrap>
                            <SliderWrap>
                                {renderline()}
                                    {renderSliderTrack()}
                                {renderScale()}
                                <Slider id='observableSlider' type="range" min="0" max={`${maxStep}`} step="1" value={seatValue} onInput={sliderInput} paddingValue={paddingValue}/>
                                <SliderOutputWrap paddingValue={paddingValue}>
                                    <SliderOutput maxStep={maxStep} seatValue={seatValue}>{seatValue}</SliderOutput>
                                </SliderOutputWrap>
                            </SliderWrap>
                            <PriceWrap paddingValue={paddingValue}>
                                <PriceContent>
                                    <PriceValue left>0</PriceValue>
                                </PriceContent>
                                <PriceContent>
                                    {maxStep <= 15 && <PriceValue left>{maxStep*1/3}</PriceValue>}
                                </PriceContent>
                                <PriceContent>
                                    {maxStep <= 15 && <PriceValue left>{maxStep*2/3}</PriceValue>}
                                    <PriceValue right>{maxStep}+</PriceValue>
                                </PriceContent>
                                {/* <BuyMore visible={seatValue >= maxStep}></BuyMore> */}
                            </PriceWrap>
                            {condition === 'Payment' && renderRegularPayment()}
                            {condition === 'Management' && renderManagement()}
                        </Wrap>
                    </Content>
                </Container>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(AgencyPayment));

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 0 120px 0;
    font-size: 20px;
    font-weight: 500;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    transition: all .2s ease-in-out;
    overflow: scroll;
    @media (max-width: 900px){
        align-items: initial;
    }    
`
const Content = styled.div`
    width: 900px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
`
const Wrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: ${props => props.direction};
    padding: ${({ padding }) => padding};
    border-bottom: ${({ borderBottom }) => borderBottom ? '1px solid rgb(230, 230, 230)' : ''};
    margin-top: ${({top}) => top};
`
const Title = styled.div`
    display: flex;
    align-items: center;
    font-size: ${({ fontSize }) => fontSize ? fontSize : '28px;'};
    font-weight: 500;
    min-height: ${({height}) => height};
    span {
        color: #787878;
        font-size: 15px;
        padding-left: 12px;
    }
`
const PriceWrap = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: repeat(3,1fr);
    grid-template-rows: auto;
    width: 100%;
    padding: ${({ paddingValue }) => `0 ${paddingValue}px`};
`
const PriceContent = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 500;
    ${({ small }) => small ? 'font-size: 14px; color: #787878;' : ''};
`
const PriceValue = styled.div`
    position: absolute;
    left: ${props => props.left ? 0: ''};
    right: ${props => props.right ? 0: ''};
    transform: ${props => props.left ? 'translateX(-50%)' : 'translateX(50%)'};
    font-size: 12px;
`
const SliderWrap = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    height: 24px;
    margin: 10px 0;
`
const Slider = styled.input`
    position: absolute;
    -webkit-appearance: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: transparent;
    border: 0;
    padding: ${({ paddingValue }) => `0 ${paddingValue}px`};
    &:focus {
        outline: none;
    }
`
const SliderOutputWrap = styled.div`
    position: relative;
    pointer-events: none;
    /* width: calc(100% - 48px); */
    width: ${({ paddingValue }) => `calc(100% - ${(paddingValue *2)}px)`};
`
const SliderOutput = styled.div`
    position: absolute;
    display: flex;
    visibility: hidden;
    opacity: 0;
    align-items: center;
    justify-content: center;
    top: -10px;
    left: ${props => `${props.seatValue / props.maxStep * 100}%`};
    min-width: 60px;
    height: 40px;
    background-color: ${props => props.seatValue <= 5 ? '#de0606'
        : props.seatValue <= 10 ? '#ee8282'
            : '#f5b4b4'};
    transform: translate(-50%, -100%);
    color: #fff;
    border-radius: 100px;
    white-space: nowrap;
    font-weight: bold;
    font-size: 1.2em;
    text-align: center;
    transition: visibility 0.3s linear,opacity 0.3s linear;
    &:before {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        border: 10px solid #383c42;
        border-color: ${props => props.seatValue <= 5 ? '#de0606'
        : props.seatValue <= 10 ? '#ee8282'
            : '#f5b4b4'};
        border-bottom: none;
        border-left-color: transparent;
        border-right-color: transparent;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
    ${SliderWrap}:hover & {
        visibility: visible;
        opacity: .95;
    }
`
const SliderTrackWrap = styled.div`
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: ${({ paddingValue }) => `0 ${paddingValue}px`};
`
const SliderTrack = styled.div`
    width: ${({ width, transparentPart }) => transparentPart > 0 ? `${width * transparentPart}%` : '0%'};
    margin: 8px 0;
    background-color: ${({ backgroundColor }) => backgroundColor};
`
const ScaleWrap = styled.div`
    position: absolute;
    width: 100%;
    height: 24px;
    pointer-events: none;
    svg{
        width: 100%;
        pointer-events: none;
    }
`
const SeatContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`
const SeatInput = styled.input`
    padding-left: 10px;
    width: 90px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #979797;
    border-right: ${({border}) => border ? '': 0};
    &:focus {
        outline: none;
    }
`
const SeatUser = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #979797;
    border-left: 0;
`
const SeatSubmit = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    border-left: 0;
    font-size: 14px;
    font-weight: 300;
    background-color: ${props => props.isSubmitDisabled ? "#a0a0a0" : "#e94242"};
    cursor: ${props => props.isSubmitDisabled? 'not-allowed' : 'pointer'};
    color: #fff;
`
const SeatError = styled.div`
    display: flex;
    color: #de0606;
    font-size: 14px;
    font-weight: 500;
    min-height: 1.2rem;
`
const NoteWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    color: #787878;
    div{
        display: flex;
        align-items: center;
        justify-content: center;  
    }
    span {
        color: #de0606;
        padding-left: .5em;
    }
`
const ManagementWrap = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: auto;
    width: 100%;
    padding: ${({ paddingValue }) => `24px ${paddingValue}px`};
`
const ManagementTitle = styled.div`
    display: flex;
    align-items: center; 
    min-height: 1.5rem;
    font-size: 14px;
    color: #787878;
    span {
        color: #de0606;
        padding-left: .5em;
    }
    div {
        margin-left: 8px;
    }
`
const EditButtonWrap = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    bottom: 0;
    right: 0;
`
const EditButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    margin: 0 8px;
    color: ${({ condition }) => (condition === 'comfirm' && '#fff') || (condition === 'cancel' && '#787878')};;
    font-size: 16px;
    background-color: ${({ condition }) => (condition === 'comfirm' && '#de0606') || (condition === 'cancel' && 'transparent')};
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
    ${({ isActive }) => isActive ? '' : 'cursor: not-allowed; background-color: #787878; color: #fff;'};
    &:hover {
        opacity: 1;
    }
`
const Response = styled.div`
    color: #de0606;
`


// WEBPACK FOOTER //
// ./src/Payment/AgencyPayment.js